import { createI18n } from 'vue-i18n';
import en from "./en.json";
import vi from "./vi.json";

export const i18n = createI18n({
    messages: {
        en: en,
        vi: vi
    },
    fallbackLocale: 'en',
    locale: 'en'
});